import { QueryClient } from "@tanstack/react-query";

const statusFor = (error: unknown) =>
  error && typeof error === "object" && "status" in error
    ? Number(error.status)
    : undefined;

export const createPortalQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        gcTime: 10 * 60 * 1000,
        refetchOnReconnect: true,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          const status = statusFor(error);
          if (status === 401 || status === 403) return false;
          return failureCount < 1;
        },
        staleTime: 30 * 1000,
      },
      mutations: {
        retry: false,
      },
    },
  });

export const queryClient = createPortalQueryClient();
